import { useState, useEffect, useCallback } from 'react';
import {
  Container,
  Stack,
  Typography,
  Select,
  MenuItem,
  Button,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField
} from '@mui/material';
import { Document, pdfjs, Page as Pages } from 'react-pdf';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import { Box } from '@mui/system';
import { Link as RouterLink, useNavigate, useParams } from 'react-router-dom';
import inputValidation from '../../utils/globalValidation';
import BrudCrumbs from '../../components/BreadCrumbs';
import Page from '../../components/Page';
import PageTitle from '../../components/PageHeading';
import photoDummy from './dummy/photoDummy.jpg';
import aadharFrontDummy from './dummy/aadharFrontDummy.jpg';
import aadharBackDummy from './dummy/aadharBackDummy.png';
import panCardDummy from './dummy/panCardDummy.jpg';
import cancelChequeDummy from './dummy/cancelChequeDummy.png';
import gstRegistrationCertificate from './dummy/GSTRegistrationCertificate.jpg';
// import gstin from './dummy/gstin.pdf';
import CustomDate from '../../components/CustomDate';
import incorporationCertificate from './dummy/certificateIncorporation.jpg';
import logoDummy from './dummy/logoDummy.png';
import ErrorDialog from '../Global/ErrorDialog';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';
import useGlobalSelector from '../../store/Slice/Global/GlobalSelector';
import {
  getCityData,
  getDocsTypesData,
  getPartnerCompanyType,
  getPartnerTypesData,
  getStateData,
  saveApiData,
  savefileApiData,
  setCityData
} from '../../store/Slice/Global/GlobalSlice';
import CustomSelect from '../../components/CustomSelect';
import CustomInput from '../../components/CustomInput';
import { OnboardingApi } from '../../utils/Apis';
import { setApiError } from '../../store/Slice/Error/ErrorSlice';
import { isValidValue } from '../../utils/CommonFunction';
import useOnboardingSelector from '../../store/Slice/Onboarding/OnboardingSelector';
import { VerifyFileData } from '../../store/Slice/Onboarding/OnboardingSlice';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

function AddEditOnBoarding() {
  const [partnerType1, setPartnerType1] = useState('');
  const [photoPreview, setPhotoPreview] = useState(photoDummy);
  const [aadharFrontPreview, setAadharFrontPreview] = useState(aadharFrontDummy);
  const [aadharBackPreview, setAadharBackPreview] = useState(aadharBackDummy);
  const [panPreview, setPanPreview] = useState(panCardDummy);
  const [chequePreview, setChequePreview] = useState(cancelChequeDummy);
  const [uploadPhoto, setUploadPhoto] = useState(); // uploaded image file frontside
  const [uploadImageFileFront, setUploadImageFileFront] = useState(null); // uploaded image file frontside
  const [uploadImageFileBack, setUploadImageFileBack] = useState(null); // uploaded image file backside
  const [uploadPanImage, setUploadPanImage] = useState();
  const [uploadChequeImage, setUploadChequeImage] = useState();
  const [errorOpen, setErrorOpen] = useState(false);
  const [gstImage, setGstImage] = useState();
  const [panPreview1, setPanPreview1] = useState(panCardDummy);
  const [gstPreview, setGstPreview] = useState(gstRegistrationCertificate);
  const [gstPreviewtype1, setGstPreviewtype1] = useState('');
  const [incorporationPreviewtype1, setIncorporationPreviewtype1] = useState('');
  const [panPreview1type1, setPanPreview1type1] = useState('');
  const [chequePreview1type1, setChequePreview1type1] = useState('');
  const [panPreviewtype1, setPanPreviewtype1] = useState('');
  const [chequePreviewtype1, setChequePreviewtype1] = useState('');
  const [logoPreviewtype1, setLogoPreviewtype1] = useState('');
  const [photoPreviewtype1, setPhotoPreviewtype1] = useState('');
  const [aadharFrontPreviewtype1, setAadharFrontPreviewtype1] = useState('');
  const [incorporationPreview, setIncorporationPreview] = useState(incorporationCertificate);
  const [incorporationUploadComp, setIncorporationUploadComp] = useState();
  const [uploadPanImageCompany, setUploadPanImageCompany] = useState();
  const [chequePreview1, setChequePreview1] = useState(cancelChequeDummy);
  const [uploadChequeCompany, setUploadChequeCompany] = useState();
  const [logoPreview, setLogoPreview] = useState(logoDummy);
  const [logoUpload, setLogoUpload] = useState();
  const [pageNumber, setPageNumber] = useState(1); // setting 1 to show fisrt page
  const [otpOpen, setOtpOpen] = useState(false);
  const [otpMobileOpen, setOtpMobileOpen] = useState(false);
  const [otpValue, setOtpValue] = useState('');
  const [otpMobileValue, setOtpMobileValue] = useState('');
  const [isEmailVerified, setIsEmailVerified] = useState(false);
  const [isMobileVerified, setIsMobileVerified] = useState(false);
  const [otpLoading, setOtpLoading] = useState(false);

  const [aadharModalOpen, setAadharModalOpen] = useState(false);
  const [aadharNumber, setAadharNumber] = useState('');
  const [aadharOtpValue, setAadharOtpValue] = useState('');
  const [otpGenerated, setOtpGenerated] = useState(false);
  const [isAadharVerified, setIsAadharVerified] = useState(false);
  const [aadharOtpLoading, setAadharOtpLoading] = useState(false);

  const [panModalOpen, setPanModalOpen] = useState(false);
  const [panNumber, setPanNumber] = useState('');
  const [panName, setPanName] = useState('');
  const [panDob, setPanDob] = useState('');
  const [uploadPanForVerification, setUploadPanForVerification] = useState(null);
  const [panPreviewForVerification, setPanPreviewForVerification] = useState('');
  const [isPanVerified, setIsPanVerified] = useState(false);
  const [panVerificationLoading, setPanVerificationLoading] = useState(false);
  const [verifyMail, setVerifyMail] = useState(false);
  const [verifyMobile, setVerifyMobile] = useState(false);

  const { rowId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { LoginData } = useLoginSelector();
  const { stateDrop, CityDrop, DocsTypesDrop, PartnerStatusDrop, PartnerCompanyTypesDrop } =
    useGlobalSelector();
  const { ReportingManagerListData } = useOnboardingSelector();

  const {
    handleSubmit: handleReduxSubmit,
    control,
    setValue,
    reset,
    watch,
    setError,
    formState: { errors }
  } = useForm({
    mode: 'onBlur', // Add this to validate on blur
    defaultValues: {
      partnerName: '',
      dob: '',
      mobile: '',
      emailAddress: '',
      loanTypeId: '',
      misMonth: ''
    }
  });

  const relationshipManager = watch('relationshipManager');
  const emailAddress = watch('emailAddress');
  const mobile = watch('mobile');

  // console.log('sss emailAddress', emailAddress);
  // console.log('sss verifyMail', verifyMail);

  useEffect(() => {
    if (!emailAddress) {
      setVerifyMail(false);
      return;
    }
    const result = inputValidation({ target: { value: emailAddress } }, 'EMAIL');
    setVerifyMail(result === true);
  }, [emailAddress]);

  useEffect(() => {
    if (!mobile) {
      setVerifyMobile(false);
      return;
    }
    const result = inputValidation({ target: { value: mobile } }, 'MOBILE');
    setVerifyMobile(result === true);
  }, [mobile]);

  useEffect(() => {
    const list = ReportingManagerListData || [];
    const selected = list.find((u) => String(u.userId) === String(relationshipManager));
    const name = selected ? selected.fullName || selected.email || '' : '';
    sessionStorage.setItem('relationshipManagerSelected', name);
  }, [relationshipManager, ReportingManagerListData]);

  const stateSelected = watch('provinceId') || null;

  useEffect(() => {
    if (PartnerStatusDrop && PartnerStatusDrop.length > 0) {
      // Find Individual type (value: 66) or use first as fallback
      const individualType = PartnerStatusDrop.find((item) => item?.value === 66);
      setPartnerType1(individualType?.value || PartnerStatusDrop?.[0]?.value);
    }
  }, [PartnerStatusDrop]);

  // File upload functions UI
  const handleFileUpload = (e, setPreview, setUploadImage, setLocaltype) => {
    const file = e.target?.files?.[0] || e.dataTransfer?.files?.[0];

    if (!file) return;

    setLocaltype(file.name.split('.').pop());
    setUploadImage(file);
    setPreview(URL.createObjectURL(file));
  };

  useEffect(() => {}, [uploadPhoto]);

  function onDocumentLoadSuccess({ numPages }) {
    setPageNumber(1);
  }

  const dragOver = (e) => {
    e.preventDefault();
  };

  const dragEnter = (e) => {
    e.preventDefault();
  };

  const dragLeave = (e) => {
    e.preventDefault();
  };

  const fileDrop = (e, setPreview, setUploadImage, setLocaltype) => {
    e.preventDefault();
    handleFileUpload(e, setPreview, setUploadImage, setLocaltype);
  };

  //  city api
  const handleGetCity = useCallback(
    (optionVal) => {
      if (!optionVal) {
        dispatch(setCityData([])); // city data
        setValue('districtId', null);
        return '';
      }
      const data = {
        stateId: optionVal,
        searchLiteral: ''
      };
      dispatch(getCityData(data)); // fetch city data
    },
    [LoginData?.companyId, LoginData?.userId] // dependencies
  );

  const onSubmit = useCallback(
    async (data) => {
      if (partnerType1 === 66) {
        if (!isValidValue(data?.dob)) {
          setError('dob', {
            type: 'manual', // 'manual' indicates programmatically set
            message: 'Date of Birth is required' // error message shown to user
          });
          return;
        } else if (data?.dob) {
          const birthDate = new Date(data?.dob);
          const today = new Date();
          let age = today.getFullYear() - birthDate.getFullYear();
          const monthDiff = today.getMonth() - birthDate.getMonth();
          if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
            age--;
          }
          if (age < 18) {
            setError('dob', {
              type: 'manual', // 'manual' indicates programmatically set
              message: 'Age should be greater than 18 years' // error message shown to user
            });
            return ''; // Age is less than 18
          }
        }
      }
      const finalData = {
        ...data, // mobile, emailAddress, address, provinceId, districtId, etc.
        partnerName: data?.partnerName || data?.companyName,
        companyId: LoginData?.companyId,
        userId: LoginData?.userId,
        typeId: partnerType1,
        countryId: 101,
        reportingManagerId: LoginData?.userId,

        // 🔹 match backend’s successful payload
        isSignUpFlow: true,
        isAgreementChecked: true,
        accessType: 'LEAD',
        isNextUserAllowed: false,
        isPartnerLoginAllowed: false,

        // 🔹 make sure this goes
        relationshipManager: data?.relationshipManager ?? null

        // 🔹 needed for edit; null for create
      };

      try {
        const res = await dispatch(saveApiData(OnboardingApi?.onboardCreatePartner, finalData));
        // console.log('sss result of create partner', res);
        if (res?.data?.status === 'success') {
          const PartnerId = res?.data?.partnerId;
          const CompanyIds = res?.data?.companyId;

          if (res?.data.isPartnerAlreadyExist) {
            dispatch(setApiError('Mobile Number Already Available'));
            return;
          }

          // Reusable document upload function
          const uploadDocument = async (file, typeCode, fieldName) => {
            // console.log('doc info ', file, typeCode, fieldName);
            if (!file || file.size <= 0) return;

            try {
              const formData = new FormData();
              formData.append('partnerId', PartnerId);
              formData.append('companyId', CompanyIds);

              const docType = DocsTypesDrop.find((item) => item.typeCode === typeCode);
              if (docType) formData.append('documentTypeId', docType.value);

              formData.append(fieldName, file);
              const token = LoginData?.jwt;
              // const result = await dispatch(saveApiData(OnboardingApi?.onboardDocUpload, formData));
              const result = await dispatch(
                savefileApiData(`${OnboardingApi?.onboardDocUpload}`, formData, token)
              );
              console.log('result of files', result);
              if (result && result?.status === 'success') {
                console.log(`${typeCode} upload successful:`, result);
              } else {
                console.error(`${typeCode} upload failed:`, result);
              }
            } catch (error) {
              console.error(`Error uploading ${typeCode}:`, error);
            }
          };
          // console.log('sss uploadPhoto', uploadPhoto);
          // List of documents to upload
          const documents = [
            { file: uploadPhoto, typeCode: 'USER IMAGE', fieldName: 'userImage' },
            { file: uploadImageFileFront, typeCode: 'AADHAR CARD', fieldName: 'aadharFront' },
            { file: uploadImageFileBack, typeCode: 'AADHAR CARD', fieldName: 'aadharBack' },
            { file: uploadPanImage, typeCode: 'PAN CARD', fieldName: 'panCard' },
            { file: uploadChequeImage, typeCode: 'CHEQUE', fieldName: 'cheque' },
            { file: logoUpload, typeCode: 'COMPANY_LOGO', fieldName: 'companyLogo' },
            { file: gstImage, typeCode: 'GSTIN', fieldName: 'gstInDocument' },
            {
              file: incorporationUploadComp,
              typeCode: 'INCORPORATION_CERTIFICATE',
              fieldName: 'incorporationCertificate'
            },
            { file: uploadPanImageCompany, typeCode: 'PAN CARD', fieldName: 'panCard' },
            { file: uploadChequeCompany, typeCode: 'CHEQUE', fieldName: 'cheque' }
          ];

          await Promise.all(
            documents.map((doc) => uploadDocument(doc?.file, doc?.typeCode, doc?.fieldName))
          );

          localStorage.setItem('partnerId', PartnerId);
          dispatch(setApiError('Partner created successfully'));
          navigate('/onboarding');
        }
      } catch (error) {
        console.error('Error submitting form:', error);
      }
    },
    [
      LoginData,
      partnerType1,
      uploadPhoto,
      uploadImageFileFront,
      uploadImageFileBack,
      uploadPanImage,
      uploadChequeImage,
      logoUpload,
      gstImage,
      incorporationUploadComp,
      uploadPanImageCompany,
      uploadChequeCompany
    ] // 🔹 depends on LoginData
  );

  const handlePartnerType = (e) => {
    reset();
    setPartnerType1(e.target.value);
    setPhotoPreview(photoDummy);
    setAadharFrontPreview(aadharFrontDummy);
    setAadharBackPreview(aadharBackDummy);
    setPanPreview(panCardDummy);
    setChequePreview(cancelChequeDummy);
    setGstPreview(gstRegistrationCertificate);
    setPanPreview1(panCardDummy);
    setChequePreview1(cancelChequeDummy);
    setIncorporationPreview(incorporationCertificate);
    setLogoPreview(logoDummy);
  };

  //  state list
  const getStateList = () => {
    const data = {
      countryId: 101
    };
    dispatch(getStateData(data));
  };

  useEffect(() => {
    dispatch(getPartnerTypesData()); // partner types
    dispatch(getPartnerCompanyType()); // partner company types
    dispatch(getDocsTypesData()); // docs types
    getStateList(); // state list
  }, []);

  async function handleEmailSend() {
    if (!emailAddress) {
      dispatch(setApiError('Please enter email'));
      return;
    }
    const payload = { email: emailAddress };
    try {
      const result = await dispatch(saveApiData(OnboardingApi?.onBoardEmailSend, payload));
      if (result?.status === 'success') {
        setOtpOpen(true); //  open popup
        dispatch(setApiError('OTP sent to your mail id'));
      }
    } catch (err) {
      console.error(err);
    }
  }

  async function handleEmailVerifyOtp() {
    if (!otpValue) {
      dispatch(setApiError('Please enter OTP'));
      return;
    }

    setOtpLoading(true);

    const payload = {
      email: emailAddress,
      otp: otpValue
    };

    try {
      const result = await dispatch(saveApiData(OnboardingApi?.onBoardEmailVerify, payload));

      if (result?.status === 'success') {
        setIsEmailVerified(true);
        setOtpOpen(false);
        setOtpValue('');
        dispatch(setApiError('Email verified successfully'));
      }
    } catch (err) {
      console.error(err);
    } finally {
      setOtpLoading(false);
    }
  }

  async function handleMobileSend() {
    if (!mobile) {
      dispatch(setApiError('Please enter mobile number'));
      return;
    }
    const payload = { mobileNumber: mobile };
    try {
      const result = await dispatch(saveApiData(OnboardingApi?.onBoardMobileSend, payload));
      if (result?.success === true) {
        setOtpMobileOpen(true); //  open popup
        dispatch(setApiError('OTP sent to your mobile number'));
      }
    } catch (err) {
      console.error(err);
    }
  }

  async function handleMobileVerifyOtp() {
    if (!otpMobileValue) {
      dispatch(setApiError('Please enter OTP'));
      return;
    }

    setOtpLoading(true);

    const payload = {
      mobileNumber: mobile,
      otp: otpMobileValue
    };

    try {
      const result = await dispatch(saveApiData(OnboardingApi?.onBoardMobileVerify, payload));

      if (result?.success === true) {
        setIsMobileVerified(true);
        setOtpMobileOpen(false);
        setOtpMobileValue('');
        dispatch(setApiError(result?.message || 'Mobile verified successfully'));
      }
    } catch (err) {
      console.error(err);
    } finally {
      setOtpLoading(false);
    }
  }

  async function handleAadharSend() {
    if (!aadharNumber) {
      dispatch(setApiError('Please enter Aadhar number'));
      return;
    }
    if (!uploadImageFileFront) {
      dispatch(setApiError('Please upload Aadhar document'));
      return;
    }

    setAadharOtpLoading(true);

    try {
      const formData = new FormData();
      formData.append('aadhaar_no', aadharNumber);
      formData.append('aadhaar_doc', uploadImageFileFront);
      formData.append('client_id', 'pb');
      formData.append('userId', 'system');

      // Replace with actual API endpoint
      const result = await dispatch(savefileApiData(OnboardingApi?.onBoardAadharSend, formData));

      if (result?.success === true) {
        setOtpGenerated(true); // Store ref_id for verification
        dispatch(setApiError('OTP sent to your registered mobile'));
      } else {
        dispatch(setApiError(result?.message || 'Failed to send OTP'));
      }
    } catch (err) {
      console.error(err);
      dispatch(setApiError('Error sending OTP'));
    } finally {
      setAadharOtpLoading(false);
    }
  }

  async function handleAadharVerifyOtp() {
    if (!aadharOtpValue) {
      dispatch(setApiError('Please enter OTP'));
      return;
    }

    setAadharOtpLoading(true);

    const payload = {
      otp: aadharOtpValue,
      ref_id: 46538513,
      client_id: 'pb',
      userId: 'system'
    };

    try {
      const result = await dispatch(VerifyFileData(OnboardingApi?.onBoardAadharVerify, payload));

      if (result?.success === true) {
        setIsAadharVerified(true);
        setAadharModalOpen(false);
        setAadharOtpValue('');
        dispatch(setApiError(result?.message || 'Aadhar verified successfully'));
      } else {
        dispatch(setApiError(result?.message || 'OTP verification failed'));
      }
    } catch (err) {
      console.error(err);
      dispatch(setApiError('Error verifying OTP'));
    } finally {
      setAadharOtpLoading(false);
    }
  }

  async function handlePanVerify() {
    if (!panNumber) {
      dispatch(setApiError('Please enter PAN number'));
      return;
    }
    if (!panName) {
      dispatch(setApiError('Please enter full name'));
      return;
    }
    if (!panDob) {
      dispatch(setApiError('Please enter date of birth'));
      return;
    }
    if (!uploadPanForVerification) {
      dispatch(setApiError('Please upload PAN document'));
      return;
    }

    setPanVerificationLoading(true);

    try {
      const formData = new FormData();
      formData.append('pan_no', panNumber.toUpperCase());
      formData.append('name', panName.toUpperCase());
      formData.append('dob', panDob);
      formData.append('pan_doc', uploadPanForVerification);
      formData.append('client_id', 'pb');
      formData.append('userId', 'system');

      // Replace with your actual API endpoint
      const result = await dispatch(savefileApiData(OnboardingApi?.verifyPan, formData));

      if (result?.success === true) {
        setIsPanVerified(true);
        setPanModalOpen(false);

        const previewUrl = URL.createObjectURL(uploadPanForVerification);

        // ✅ Update PAN preview on main card
        setPanPreview(previewUrl);
        setPanPreviewtype1(uploadPanForVerification.name.split('.').pop());

        // ✅ MOST IMPORTANT → Save file for upload API
        setUploadPanImage(uploadPanForVerification);

        dispatch(setApiError(result?.message || 'PAN verified successfully'));

        // Reset modal states
        setPanNumber('');
        setPanName('');
        setPanDob('');
        setUploadPanForVerification(null);
        setPanPreviewForVerification('');
      } else {
        dispatch(setApiError(result?.message || 'PAN verification failed'));
      }
    } catch (err) {
      console.error(err);
      dispatch(setApiError('Error verifying PAN'));
    } finally {
      setPanVerificationLoading(false);
    }
  }

  return (
    <Page title="Kpros by Kalolytic Solutions || On Boarding">
      <Container maxWidth="xl">
        <Box pt={3} pb={3} mb={4}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            className="pageHeading"
          >
            <PageTitle info={rowId ? 'Edit Partner' : 'Add New Partner'} />
            <Box>
              <BrudCrumbs />
            </Box>
          </Stack>
          <Grid container spacing={3}>
            <Grid item xs={4}>
              <Box mb={3}>
                <Typography variant="h6" className="formLabel">
                  Partner Type
                </Typography>
                <Select
                  fullWidth
                  inputProps={{
                    className: 'textInput'
                  }}
                  value={partnerType1}
                  onChange={(e) => {
                    handlePartnerType(e);
                  }}
                >
                  <MenuItem value=" " disabled>
                    Select Partner Type
                  </MenuItem>
                  {PartnerStatusDrop?.length > 0 &&
                    PartnerStatusDrop?.map((item) => (
                      <MenuItem value={item?.value} key={item?.value}>
                        {item?.label}
                      </MenuItem>
                    ))}
                </Select>
              </Box>
            </Grid>
          </Grid>
          <form id="myOnboardingForm" onSubmit={handleReduxSubmit(onSubmit)}>
            {partnerType1 &&
              (partnerType1 === 66 ? (
                <>
                  <Typography variant="body1" className="headingLineUp headingLineUpOut">
                    Individual Details
                  </Typography>
                  <Box className="viewLeadCard cardTopMinusMargin" mb={3}>
                    <Grid container spacing={3} mb={3}>
                      <Grid item xs={4}>
                        <CustomInput
                          name="partnerName"
                          label="Full Name"
                          control={control}
                          errors={errors}
                          isRequired
                          fieldCode="NAME"
                          fieldType="ALPHABET"
                        />
                      </Grid>
                      <Grid item xs={4}>
                        <CustomInput
                          name="fathersName"
                          label="Father Name"
                          control={control}
                          errors={errors}
                          isRequired
                        />
                      </Grid>
                      <Grid item xs={4}>
                        {/* <CustomInput
                          name="dob"
                          label="Date of Birth"
                          type="date"
                          control={control}
                          errors={errors}
                          isRequired
                          // fieldCode="DOB"
                          fieldType="DATE_FIELD"
                        /> */}
                        <CustomDate
                          name="dob"
                          label="Date of Birth"
                          control={control}
                          errors={errors}
                          isRequired
                          fieldCode="DATE"
                          fieldType="DATE_FIELD"
                        />
                      </Grid>
                      <Grid item xs={4}>
                        <Box
                          sx={{
                            display: 'grid',
                            gridTemplateColumns: '1fr 90px',
                            gap: 1.5,
                            alignItems: 'end',
                            width: '100%'
                          }}
                        >
                          <CustomInput
                            name="mobile"
                            label="Mobile"
                            control={control}
                            errors={errors}
                            isRequired
                            fieldCode="MOBILE"
                            fieldType="NUMBER_FIELD"
                            disabled={isMobileVerified}
                          />
                          <Button
                            variant="contained"
                            size="small"
                            disabled={isMobileVerified}
                            sx={{
                              minWidth: '90px',
                              height: '37px',
                              backgroundColor: isMobileVerified
                                ? '#2e7d32!important'
                                : verifyMobile
                                ? '#0d4689!important'
                                : '#95989bcc',
                              color: '#fff!important',
                              '&:hover': {
                                backgroundColor: isMobileVerified ? '#1b5e20' : '#95989bcc'
                              }
                            }}
                            onClick={() => handleMobileSend()}
                          >
                            {isMobileVerified ? 'Verified' : 'Verify'}
                          </Button>
                        </Box>
                      </Grid>
                      <Grid item xs={4}>
                        <Box
                          sx={{
                            display: 'grid',
                            gridTemplateColumns: '1fr 90px',
                            gap: 1.5,
                            alignItems: 'flex-end',
                            width: '100%'
                          }}
                        >
                          <CustomInput
                            name="emailAddress"
                            label="Email"
                            control={control}
                            errors={errors}
                            isRequired
                            fieldCode="EMAIL"
                          />
                          <Button
                            variant="contained"
                            size="small"
                            disabled={isEmailVerified}
                            sx={{
                              minWidth: '90px',
                              height: '37px',
                              backgroundColor: isEmailVerified
                                ? '#2e7d32!important'
                                : verifyMail
                                ? '#0d4689!important'
                                : '#95989bcc',
                              color: '#fff!important',
                              '&:hover': {
                                backgroundColor: isEmailVerified ? '#1b5e20' : '#95989bcc'
                              }
                            }}
                            onClick={() => handleEmailSend()}
                          >
                            {isEmailVerified ? 'Verified' : 'Verify'}
                          </Button>
                        </Box>
                      </Grid>
                      <Grid item xs={4}>
                        <CustomInput
                          name="address"
                          label="Address"
                          control={control}
                          errors={errors}
                          isRequired
                        />
                      </Grid>
                      <Grid item xs={4}>
                        <CustomSelect
                          name="provinceId"
                          label="State"
                          control={control}
                          errors={errors}
                          options={stateDrop || []}
                          onChange={(event, val, option, reason, details) => {
                            handleGetCity(val);
                          }}
                          isRequired
                        />
                      </Grid>
                      <Grid item xs={4}>
                        <CustomSelect
                          name="districtId"
                          label="City"
                          control={control}
                          errors={errors}
                          options={CityDrop || []}
                          disabled={!stateSelected}
                          isRequired
                        />
                      </Grid>
                      <Grid item xs={4}>
                        <CustomSelect
                          name="relationshipManager"
                          label="Relationship manager"
                          control={control}
                          errors={errors}
                          options={
                            ReportingManagerListData.map((user) => ({
                              value: user.userId,
                              label: user.fullName
                            })) || []
                          }
                        />
                      </Grid>
                    </Grid>{' '}
                  </Box>
                  <Typography variant="body1" className="headingLineUp headingLineUpOut">
                    Upload Documents
                  </Typography>
                  <Box className="viewLeadCard cardTopMinusMargin" mb={3}>
                    <Grid container spacing={3}>
                      <Grid item xs={4}>
                        <Box className="">
                          <Typography variant="h6" className="formLabel">
                            Photo
                          </Typography>
                          <input
                            accept="image/png, image/gif, image/jpeg, application/pdf"
                            className="fileInput"
                            id="contained-button-file1"
                            multiple
                            type="file"
                            onChange={(e) =>
                              handleFileUpload(
                                e,
                                setPhotoPreview,
                                setUploadPhoto,
                                setPhotoPreviewtype1
                              )
                            }
                          />
                          <label
                            htmlFor="contained-button-file1"
                            className={
                              photoPreviewtype1 === 'pdf'
                                ? `pdfBox uploadDocBoxLabel uploadDocBoxLabelFull`
                                : `uploadDocBoxLabel uploadDocBoxLabelFull`
                            }
                          >
                            <Box
                              variant="contained"
                              color="primary"
                              component="span"
                              onDragOver={dragOver}
                              onDragEnter={dragEnter}
                              onDragLeave={dragLeave}
                              onDrop={(e) =>
                                handleFileUpload(
                                  e,
                                  setPhotoPreview,
                                  setUploadPhoto,
                                  setPhotoPreviewtype1
                                )
                              }
                              display="flex"
                              flexDirection="column"
                              alignItems="center"
                            >
                              {photoPreviewtype1 === 'pdf' ? (
                                <Document
                                  file={photoPreview}
                                  onLoadSuccess={(numPages) => onDocumentLoadSuccess(numPages)}
                                >
                                  <Pages pageNumber={pageNumber} />
                                </Document>
                              ) : (
                                <img src={photoPreview} alt="Person" className="previewImage" />
                              )}
                            </Box>
                          </label>
                        </Box>
                      </Grid>

                      <Grid item xs={4}>
                        <Box className="">
                          <Typography variant="h6" className="formLabel">
                            Aadhar
                          </Typography>
                          {/* <input
                            accept="image/png, image/gif, image/jpeg, application/pdf"
                            className="fileInput"
                            id="contained-button-file2"
                            multiple
                            type="file"
                            onChange={(e) =>
                              handleFileUpload(
                                e,
                                setAadharFrontPreview,
                                null,
                                setUploadImageFileFront,
                                setAadharFrontPreviewtype1
                              )
                            }
                          /> */}
                          <label
                            htmlFor="contained-button-file2"
                            className={
                              aadharFrontPreviewtype1 === 'pdf'
                                ? `pdfBox uploadDocBoxLabel uploadDocBoxLabelFull`
                                : `uploadDocBoxLabel uploadDocBoxLabelFull`
                            }
                          >
                            <Box
                              variant="contained"
                              color="primary"
                              component="span"
                              onDragOver={dragOver}
                              onDragEnter={dragEnter}
                              onDragLeave={dragLeave}
                              onDrop={(e) =>
                                fileDrop(
                                  e,
                                  setAadharFrontPreview,
                                  setUploadImageFileFront,
                                  setAadharFrontPreviewtype1
                                )
                              }
                              display="flex"
                              flexDirection="column"
                              alignItems="center"
                              sx={{ cursor: 'pointer', position: 'relative' }}
                              onClick={() => !isAadharVerified && setAadharModalOpen(true)}
                            >
                              {aadharFrontPreviewtype1 === 'pdf' ? (
                                <Document
                                  file={aadharFrontPreview}
                                  onLoadSuccess={(numPages) => onDocumentLoadSuccess(numPages)}
                                >
                                  <Pages pageNumber={pageNumber} />
                                </Document>
                              ) : (
                                <img
                                  src={aadharFrontPreview}
                                  alt="Aadhar"
                                  className="previewImage"
                                />
                              )}

                              {/* Verify Badge Overlay */}
                              {isAadharVerified && (
                                <Box
                                  sx={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: '-25px',
                                    backgroundColor: 'rgb(50 52 50 / 44%)',
                                    display: 'flex',
                                    alignItems: 'end',
                                    justifyContent: 'center',
                                    color: 'green',
                                    fontWeight: 600,
                                    borderRadius: '4px'
                                  }}
                                >
                                  <CheckCircleIcon /> Verified
                                </Box>
                              )}
                            </Box>
                          </label>
                        </Box>
                      </Grid>
                      <Grid item xs={4}>
                        <Box className="">
                          <Typography variant="h6" className="formLabel">
                            PAN Card
                          </Typography>
                          <input
                            accept="image/png, image/gif, image/jpeg, application/pdf"
                            className="fileInput"
                            id="contained-button-file3"
                            multiple
                            type="file"
                            onChange={(e) =>
                              handleFileUpload(
                                e,
                                setPanPreview,
                                setUploadPanImage,
                                setPanPreviewtype1
                              )
                            }
                          />
                          <label
                            htmlFor={isPanVerified ? 'contained-button-file3' : undefined}
                            className={
                              panPreviewtype1 === 'pdf'
                                ? `pdfBox uploadDocBoxLabel uploadDocBoxLabelFull`
                                : `uploadDocBoxLabel uploadDocBoxLabelFull`
                            }
                          >
                            <Box
                              variant="contained"
                              color="primary"
                              component="span"
                              onDragOver={dragOver}
                              onDragEnter={dragEnter}
                              onDragLeave={dragLeave}
                              onDrop={(e) =>
                                fileDrop(e, setPanPreview, setUploadPanImage, setPanPreviewtype1)
                              }
                              display="flex"
                              flexDirection="column"
                              alignItems="center"
                              sx={{ cursor: 'pointer', position: 'relative' }}
                              onClick={() => !isPanVerified && setPanModalOpen(true)}
                            >
                              {panPreviewtype1 === 'pdf' ? (
                                <Document
                                  file={panPreview}
                                  onLoadSuccess={(numPages) => onDocumentLoadSuccess(numPages)}
                                >
                                  <Pages pageNumber={pageNumber} />
                                </Document>
                              ) : (
                                <img src={panPreview} alt="Pan Card" className="previewImage" />
                              )}

                              {/* Verify Badge Overlay */}
                              {isPanVerified && (
                                <Box
                                  sx={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: '-25px',
                                    backgroundColor: 'rgb(50 52 50 / 44%)',
                                    display: 'flex',
                                    alignItems: 'end',
                                    justifyContent: 'center',
                                    color: 'green',
                                    fontWeight: 600,
                                    borderRadius: '4px'
                                  }}
                                >
                                  <CheckCircleIcon /> Verified
                                </Box>
                              )}
                            </Box>
                          </label>
                        </Box>
                      </Grid>
                      <Grid item xs={4}>
                        <Box className="">
                          <Typography variant="h6" className="formLabel">
                            Cancelled Cheque
                          </Typography>
                          <input
                            accept="image/png, image/gif, image/jpeg, application/pdf"
                            className="fileInput"
                            id="contained-button-file5"
                            multiple
                            type="file"
                            onChange={(e) =>
                              handleFileUpload(
                                e,
                                setChequePreview,
                                setUploadChequeImage,
                                setChequePreviewtype1
                              )
                            }
                          />
                          <label
                            htmlFor="contained-button-file5"
                            className={
                              chequePreviewtype1 === 'pdf'
                                ? `pdfBox uploadDocBoxLabel uploadDocBoxLabelFull`
                                : `uploadDocBoxLabel uploadDocBoxLabelFull`
                            }
                          >
                            <Box
                              variant="contained"
                              color="primary"
                              component="span"
                              onDragOver={dragOver}
                              onDragEnter={dragEnter}
                              onDragLeave={dragLeave}
                              onDrop={(e) =>
                                fileDrop(
                                  e,
                                  setChequePreview,
                                  setUploadChequeImage,
                                  setChequePreviewtype1
                                )
                              }
                              display="flex"
                              flexDirection="column"
                              alignItems="center"
                            >
                              {/* <img src={chequePreview} alt="Cancel Cheque" className="previewImage" /> */}

                              {chequePreviewtype1 === 'pdf' ? (
                                <Document
                                  file={chequePreview}
                                  onLoadSuccess={(numPages) => onDocumentLoadSuccess(numPages)}
                                >
                                  <Pages pageNumber={pageNumber} />
                                </Document>
                              ) : (
                                <img
                                  src={chequePreview}
                                  alt="Cancel Cheque"
                                  className="previewImage"
                                />
                              )}
                            </Box>
                          </label>
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>{' '}
                </>
              ) : (
                <>
                  {/* ##################### Company Code ########################################## */}

                  <Typography variant="body1" className="headingLineUp headingLineUpOut">
                    Company Details
                  </Typography>
                  <Box className="viewLeadCard cardTopMinusMargin" mb={3}>
                    <Grid container spacing={3} mb={3}>
                      <Grid item xs={4}>
                        <CustomInput
                          name="companyName"
                          label="Company Name"
                          control={control}
                          errors={errors}
                          isRequired
                          fieldCode="NAME"
                          fieldType="ALPHABET"
                        />
                      </Grid>
                      <Grid item xs={4}>
                        <CustomInput
                          name="authorisedPersonName"
                          label="Authorised Person Name"
                          control={control}
                          // errors={errors}
                        />
                      </Grid>
                      <Grid item xs={4}>
                        <Box
                          sx={{
                            display: 'grid',
                            gridTemplateColumns: '1fr 90px',
                            gap: 1.5,
                            alignItems: 'end',
                            width: '100%'
                          }}
                        >
                          <CustomInput
                            name="mobile"
                            label="Mobile Number"
                            control={control}
                            errors={errors}
                            isRequired
                            fieldCode="MOBILE"
                            fieldType="NUMBER_FIELD"
                            disabled={isMobileVerified}
                          />
                          <Button
                            variant="contained"
                            size="small"
                            disabled={isMobileVerified}
                            sx={{
                              minWidth: '90px',
                              height: '37px',
                              backgroundColor: isMobileVerified
                                ? '#2e7d32!important'
                                : verifyMobile
                                ? '#0d4689!important'
                                : '#95989bcc',
                              color: '#fff!important',
                              '&:hover': {
                                backgroundColor: isMobileVerified ? '#1b5e20' : '#95989bcc'
                              }
                            }}
                            onClick={() => handleMobileSend()}
                          >
                            {isMobileVerified ? 'Verified' : 'Verify'}
                          </Button>
                        </Box>
                      </Grid>
                      <Grid item xs={4}>
                        <Box
                          sx={{
                            display: 'grid',
                            gridTemplateColumns: '1fr 90px',
                            gap: 1.5,
                            alignItems: 'flex-end',
                            width: '100%'
                          }}
                        >
                          <CustomInput
                            name="emailAddress"
                            label="Email"
                            control={control}
                            errors={errors}
                            isRequired
                            fieldCode="EMAIL"
                          />
                          <Button
                            variant="contained"
                            size="small"
                            disabled={isEmailVerified}
                            sx={{
                              minWidth: '90px',
                              height: '37px',
                              backgroundColor: isEmailVerified
                                ? '#2e7d32!important'
                                : verifyMail
                                ? '#0d4689!important'
                                : '#95989bcc',
                              color: '#fff!important',
                              '&:hover': {
                                backgroundColor: isEmailVerified ? '#1b5e20' : '#95989bcc'
                              }
                            }}
                            onClick={() => handleEmailSend()}
                          >
                            {isEmailVerified ? 'Verified' : 'Verify'}
                          </Button>
                        </Box>
                      </Grid>
                      <Grid item xs={4}>
                        <CustomSelect
                          name="partnerCompanyTypeId"
                          label="Company Type"
                          control={control}
                          errors={errors}
                          options={PartnerCompanyTypesDrop || []}
                        />
                      </Grid>
                      <Grid item xs={4}>
                        <CustomDate
                          name="dateOfIncorporation"
                          label="Date of Incorporation"
                          control={control}
                          // errors={errors}
                          fieldCode="DATE"
                          fieldType="DATE_FIELD"
                        />
                      </Grid>
                      <Grid item xs={4}>
                        <CustomInput
                          name="companyGstNumber"
                          label="GST Number"
                          control={control}
                          // errors={errors}
                        />
                      </Grid>
                      <Grid item xs={4}>
                        <CustomInput
                          name="companyPanNumber"
                          label="PAN Number"
                          control={control}
                          // errors={errors}
                        />
                      </Grid>
                      <Grid item xs={4}>
                        <CustomInput
                          name="address"
                          label="Address"
                          control={control}
                          // errors={errors}
                        />
                      </Grid>
                      <Grid item xs={4}>
                        <CustomSelect
                          name="provinceId"
                          label="State"
                          control={control}
                          errors={errors}
                          options={stateDrop || []}
                          onChange={(event, val, option, reason, details) => {
                            handleGetCity(val);
                          }}
                        />
                      </Grid>
                      <Grid item xs={4}>
                        <CustomSelect
                          name="districtId"
                          label="City"
                          control={control}
                          errors={errors}
                          options={CityDrop || []}
                          disabled={!stateSelected}
                        />
                      </Grid>
                    </Grid>{' '}
                  </Box>
                  {/* ###################################### Company Document ########################  */}

                  <Typography variant="body1" className="headingLineUp headingLineUpOut">
                    Upload Documents
                  </Typography>
                  <Box className="viewLeadCard cardTopMinusMargin" mb={3}>
                    <Grid container spacing={3}>
                      {/* <Grid item xs={4}>
                        <Box className="">
                          <Typography variant="h6" className="formLabel">
                            Company Logo
                          </Typography>
                          <input
                            accept="image/png, image/gif, image/jpeg, application/pdf"
                            className="fileInput"
                            id="contained-button-file6"
                            multiple
                            type="file"
                            onChange={(e) =>
                              handleFileUpload(
                                e,
                                setLogoPreview,
                                setLogoUpload,
                                setLogoPreviewtype1
                              )
                            }
                          />
                          <label
                            htmlFor="contained-button-file6"
                            className={
                              logoPreviewtype1 === 'pdf'
                                ? `pdfBox uploadDocBoxLabel uploadDocBoxLabelFull`
                                : `uploadDocBoxLabel uploadDocBoxLabelFull`
                            }
                          >
                            <Box
                              variant="contained"
                              color="primary"
                              component="span"
                              onDragOver={dragOver}
                              onDragEnter={dragEnter}
                              onDragLeave={dragLeave}
                              onDrop={(e) =>
                                fileDrop(e, setLogoPreview, setLogoUpload, setLogoPreviewtype1)
                              }
                              display="flex"
                              flexDirection="column"
                              alignItems="center"
                            >
                              {logoPreviewtype1 === 'pdf' ? (
                                <Document
                                  file={logoPreview}
                                  onLoadSuccess={(numPages) => onDocumentLoadSuccess(numPages)}
                                >
                                  <Pages pageNumber={pageNumber} />
                                </Document>
                              ) : (
                                <img
                                  src={logoPreview}
                                  alt="Company Logo"
                                  className="previewImage"
                                />
                              )}
                            </Box>
                          </label>
                        </Box>
                      </Grid> */}
                      <Grid item xs={4}>
                        <Box className="">
                          <Typography variant="h6" className="formLabel">
                            GST Certificate
                          </Typography>
                          <input
                            className="fileInput"
                            id="contained-button-file7"
                            multiple
                            type="file"
                            onChange={(e) =>
                              handleFileUpload(e, setGstPreview, setGstImage, setGstPreviewtype1)
                            }
                          />
                          <label
                            htmlFor="contained-button-file7"
                            className={
                              gstPreviewtype1 === 'pdf'
                                ? `pdfBox uploadDocBoxLabel uploadDocBoxLabelFull`
                                : `uploadDocBoxLabel uploadDocBoxLabelFull`
                            }
                          >
                            <Box
                              variant="contained"
                              color="primary"
                              component="span"
                              onDragOver={dragOver}
                              onDragEnter={dragEnter}
                              onDragLeave={dragLeave}
                              onDrop={(e) =>
                                fileDrop(e, setGstPreview, setGstImage, setGstPreviewtype1)
                              }
                              display="flex"
                              flexDirection="column"
                              alignItems="center"
                            >
                              {/* <img src={gstPreview} alt="GST Certificate" className="previewImage" /> */}

                              {gstPreviewtype1 === 'pdf' ? (
                                <Document
                                  file={gstPreview}
                                  onLoadSuccess={(numPages) => onDocumentLoadSuccess(numPages)}
                                >
                                  <Pages pageNumber={pageNumber} />
                                </Document>
                              ) : (
                                <img
                                  src={gstPreview}
                                  alt="GST Certificate"
                                  className="previewImage"
                                />
                              )}
                            </Box>
                          </label>
                        </Box>
                      </Grid>
                      {/* <Grid item xs={4}>
                        <Box className="">
                          <Typography variant="h6" className="formLabel">
                            Incoporation Certificate
                          </Typography>
                          <input
                            accept="image/png, image/gif, image/jpeg, application/pdf"
                            className="fileInput"
                            id="contained-button-file8"
                            multiple
                            type="file"
                            onChange={(e) =>
                              handleFileUpload(
                                e,
                                setIncorporationPreview,
                                setIncorporationUploadComp,
                                setIncorporationPreviewtype1
                              )
                            }
                          />
                          <label
                            htmlFor="contained-button-file8"
                            className={
                              incorporationPreviewtype1 === 'pdf'
                                ? `pdfBox uploadDocBoxLabel uploadDocBoxLabelFull`
                                : `uploadDocBoxLabel uploadDocBoxLabelFull`
                            }
                          >
                            <Box
                              variant="contained"
                              color="primary"
                              component="span"
                              onDragOver={dragOver}
                              onDragEnter={dragEnter}
                              onDragLeave={dragLeave}
                              onDrop={(e) =>
                                fileDrop(
                                  e,
                                  setIncorporationPreview,
                                  setIncorporationUploadComp,
                                  setIncorporationPreviewtype1
                                )
                              }
                              display="flex"
                              flexDirection="column"
                              alignItems="center"
                            >
                              {incorporationPreviewtype1 === 'pdf' ? (
                                <Document
                                  file={incorporationPreview}
                                  onLoadSuccess={(numPages) => onDocumentLoadSuccess(numPages)}
                                >
                                  <Pages pageNumber={pageNumber} />
                                </Document>
                              ) : (
                                <img
                                  src={incorporationPreview}
                                  alt="Incorporation Certificate"
                                  className="previewImage"
                                />
                              )}
                            </Box>
                          </label>
                        </Box>
                      </Grid> */}
                      <Grid item xs={4}>
                        <Box className="">
                          <Typography variant="h6" className="formLabel">
                            PAN Card
                          </Typography>
                          <input
                            accept="image/png, image/gif, image/jpeg, application/pdf"
                            className="fileInput"
                            id="contained-button-file9"
                            multiple
                            type="file"
                            onChange={(e) =>
                              handleFileUpload(
                                e,
                                setPanPreview1,
                                setUploadPanImageCompany,
                                setPanPreview1type1
                              )
                            }
                          />
                          <label
                            htmlFor="contained-button-file9"
                            className={
                              panPreview1type1 === 'pdf'
                                ? `pdfBox uploadDocBoxLabel uploadDocBoxLabelFull`
                                : `uploadDocBoxLabel uploadDocBoxLabelFull`
                            }
                          >
                            <Box
                              variant="contained"
                              color="primary"
                              component="span"
                              onDragOver={dragOver}
                              onDragEnter={dragEnter}
                              onDragLeave={dragLeave}
                              onDrop={(e) =>
                                fileDrop(
                                  e,
                                  setPanPreview1,
                                  setUploadPanImageCompany,
                                  setPanPreview1type1
                                )
                              }
                              display="flex"
                              flexDirection="column"
                              alignItems="center"
                            >
                              {/* <img src={panPreview1} alt="Pan Card" className="previewImage" /> */}

                              {panPreview1type1 === 'pdf' ? (
                                <Document
                                  file={panPreview1}
                                  onLoadSuccess={(numPages) => onDocumentLoadSuccess(numPages)}
                                >
                                  <Pages pageNumber={pageNumber} />
                                </Document>
                              ) : (
                                <img src={panPreview1} alt="Pan Card" className="previewImage" />
                              )}
                            </Box>
                          </label>
                        </Box>
                      </Grid>
                      <Grid item xs={4}>
                        <Box className="">
                          <Typography variant="h6" className="formLabel">
                            Cancelled Cheque
                          </Typography>
                          <input
                            accept="image/png, image/gif, image/jpeg, application/pdf"
                            className="fileInput"
                            id="contained-button-file10"
                            multiple
                            type="file"
                            onChange={(e) =>
                              handleFileUpload(
                                e,
                                setChequePreview1,
                                setUploadChequeCompany,
                                setChequePreview1type1
                              )
                            }
                          />
                          <label
                            htmlFor="contained-button-file10"
                            className={
                              chequePreview1type1 === 'pdf'
                                ? `pdfBox uploadDocBoxLabel uploadDocBoxLabelFull`
                                : `uploadDocBoxLabel uploadDocBoxLabelFull`
                            }
                          >
                            <Box
                              variant="contained"
                              color="primary"
                              component="span"
                              onDragOver={dragOver}
                              onDragEnter={dragEnter}
                              onDragLeave={dragLeave}
                              onDrop={(e) =>
                                fileDrop(
                                  e,
                                  setChequePreview1,
                                  setUploadChequeCompany,
                                  setChequePreview1type1
                                )
                              }
                              display="flex"
                              flexDirection="column"
                              alignItems="center"
                            >
                              {chequePreview1type1 === 'pdf' ? (
                                <Document
                                  file={chequePreview1}
                                  onLoadSuccess={(numPages) => onDocumentLoadSuccess(numPages)}
                                >
                                  <Pages pageNumber={pageNumber} />
                                </Document>
                              ) : (
                                <img
                                  src={chequePreview1}
                                  alt="Cancel Cheque"
                                  className="previewImage"
                                />
                              )}
                            </Box>
                          </label>
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                </>
              ))}
          </form>
          <Box textAlign="right">
            <Button
              type="submit"
              form="myOnboardingForm"
              variant="contained"
              className="mainBtn"
              // disabled={isEmailVerified && isMobileVerified && isAadharVerified ? false : true}
              disabled={isEmailVerified && isMobileVerified ? false : true}
            >
              Save
            </Button>
          </Box>
          <ErrorDialog errorOpen={errorOpen} setErrorOpen={setErrorOpen} />
        </Box>

        <Dialog open={otpOpen} onClose={() => setOtpOpen(false)} maxWidth="xs" fullWidth>
          <DialogTitle sx={{ fontWeight: 600 }}>OTP sent to your mail id</DialogTitle>

          <DialogContent>
            <CustomInput
              name="otp"
              label="Enter OTP"
              control={control}
              errors={errors}
              value={otpValue}
              onChange={(e) => setOtpValue(e.target.value)}
              fieldCode="NUMBER_FIELD"
              fieldType="NUMBER_FIELD"
            />
          </DialogContent>

          <DialogActions sx={{ p: 2 }}>
            <Button
              variant="outlined"
              onClick={() => {
                setOtpOpen(false);
                setOtpValue('');
              }}
            >
              Cancel
            </Button>

            <Button
              variant="contained"
              onClick={() => handleEmailVerifyOtp()}
              disabled={otpLoading}
            >
              Verify
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={otpMobileOpen}
          onClose={() => setOtpMobileOpen(false)}
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle sx={{ fontWeight: 600 }}>OTP sent to your mobile number</DialogTitle>

          <DialogContent>
            <CustomInput
              name="otp"
              label="Enter OTP"
              control={control}
              errors={errors}
              value={otpMobileValue}
              onChange={(e) => setOtpMobileValue(e.target.value)}
              fieldCode="NUMBER_FIELD"
              fieldType="NUMBER_FIELD"
            />
          </DialogContent>

          <DialogActions sx={{ p: 2 }}>
            <Button
              variant="outlined"
              onClick={() => {
                setOtpMobileOpen(false);
                setOtpMobileValue('');
              }}
            >
              Cancel
            </Button>

            <Button
              variant="contained"
              onClick={() => handleMobileVerifyOtp()}
              disabled={otpLoading}
            >
              Verify
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={aadharModalOpen}
          onClose={() => {
            setAadharModalOpen(false);
            setAadharNumber('');
            setAadharOtpValue('');
            setOtpGenerated(false);
          }}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle sx={{ fontWeight: 600 }}>Verify Aadhar</DialogTitle>

          <DialogContent sx={{ pt: 3 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
              {/* Step 1: Image Upload & Display */}
              <Box>
                <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1.5 }}>
                  Upload Aadhar Document
                </Typography>

                {/* Hidden File Input */}
                <input
                  accept="image/png, image/gif, image/jpeg, application/pdf"
                  className="fileInput"
                  id="aadhar-modal-file-input"
                  type="file"
                  style={{ display: 'none' }}
                  onChange={(e) =>
                    handleFileUpload(
                      e,
                      setAadharFrontPreview,
                      setUploadImageFileFront,
                      setAadharFrontPreviewtype1
                    )
                  }
                />

                {/* Image Display / File Browser Button */}
                <label
                  htmlFor="aadhar-modal-file-input"
                  style={{ cursor: 'pointer', display: 'block' }}
                >
                  <Box
                    sx={{
                      border: '2px dashed #1976d2',
                      borderRadius: '8px',
                      padding: '20px',
                      textAlign: 'center',
                      backgroundColor: '#f5f5f5',
                      minHeight: '200px',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: 'pointer',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        backgroundColor: '#e3f2fd',
                        borderColor: '#1565c0'
                      }
                    }}
                  >
                    {aadharFrontPreviewtype1 === 'pdf' ? (
                      <Document
                        file={aadharFrontPreview}
                        onLoadSuccess={(numPages) => onDocumentLoadSuccess(numPages)}
                      >
                        <Pages pageNumber={pageNumber} />
                      </Document>
                    ) : aadharFrontPreview !== aadharFrontDummy ? (
                      <img
                        src={aadharFrontPreview}
                        alt="Aadhar Preview"
                        style={{
                          maxWidth: '100%',
                          maxHeight: '180px',
                          objectFit: 'contain'
                        }}
                      />
                    ) : (
                      <Box sx={{ textAlign: 'center' }}>
                        <Typography variant="body2" sx={{ color: '#666', mb: 1 }}>
                          📁 Click to browse or drag & drop
                        </Typography>
                        <Typography variant="caption" sx={{ color: '#999' }}>
                          PNG, JPG, GIF, or PDF
                        </Typography>
                      </Box>
                    )}
                  </Box>
                </label>
              </Box>

              {/* Step 2: Aadhar Number Input (show only after image is selected) */}
              {uploadImageFileFront && (
                <Box>
                  <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1.5 }}>
                    Enter Aadhar Number
                  </Typography>
                  <TextField
                    fullWidth
                    label="Aadhar Number"
                    value={aadharNumber}
                    onChange={(e) =>
                      setAadharNumber(e.target.value.replace(/\D/g, '').slice(0, 12))
                    }
                    placeholder="Enter 12-digit Aadhar number"
                    variant="outlined"
                    inputProps={{
                      maxLength: 12,
                      pattern: '[0-9]{12}'
                    }}
                    helperText={`${aadharNumber.length}/12 digits`}
                  />
                </Box>
              )}

              {/* Step 3: OTP Input (show only after OTP is sent) */}
              {otpGenerated && (
                <Box>
                  <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1.5 }}>
                    Enter OTP
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#666', mb: 2 }}>
                    OTP has been sent to your registered mobile number
                  </Typography>
                  <TextField
                    fullWidth
                    label="OTP"
                    value={aadharOtpValue}
                    onChange={(e) =>
                      setAadharOtpValue(e.target.value.replace(/\D/g, '').slice(0, 6))
                    }
                    placeholder="Enter 6-digit OTP"
                    variant="outlined"
                    inputProps={{
                      maxLength: 6,
                      pattern: '[0-9]{6}'
                    }}
                    helperText={`${aadharOtpValue.length}/6 digits`}
                  />
                </Box>
              )}
            </Box>
          </DialogContent>

          <DialogActions sx={{ p: 2, gap: 1 }}>
            <Button
              variant="outlined"
              onClick={() => {
                setAadharModalOpen(false);
                setAadharNumber('');
                setAadharOtpValue('');
                setOtpGenerated(false);
                // Don't reset the image - it will stay on the card
              }}
            >
              Close
            </Button>

            {/* Send OTP Button (show when image & aadhar number are provided) */}
            {uploadImageFileFront && !otpGenerated && (
              <Button
                variant="contained"
                onClick={() => handleAadharSend()}
                disabled={aadharOtpLoading || !aadharNumber || aadharNumber.length < 12}
                sx={{
                  minWidth: '100px'
                }}
              >
                {aadharOtpLoading ? 'Sending...' : 'Send OTP'}
              </Button>
            )}

            {/* Verify Button (show when OTP is received) */}
            {otpGenerated && (
              <Button
                variant="contained"
                onClick={() => handleAadharVerifyOtp()}
                disabled={aadharOtpLoading || !aadharOtpValue || aadharOtpValue.length < 6}
                sx={{
                  minWidth: '100px'
                }}
              >
                {aadharOtpLoading ? 'Verifying...' : 'Verify'}
              </Button>
            )}
          </DialogActions>
        </Dialog>

        <Dialog
          open={panModalOpen}
          onClose={() => {
            setPanModalOpen(false);
            setPanNumber('');
            setPanName('');
            setPanDob('');
            setUploadPanForVerification(null);
            setPanPreviewForVerification('');
          }}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle sx={{ fontWeight: 600 }}>Verify PAN</DialogTitle>

          <DialogContent sx={{ pt: 3 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
              {/* Step 1: Image Upload & Display */}
              <Box>
                <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1.5 }}>
                  Upload PAN Document
                </Typography>

                {/* Hidden File Input */}
                <input
                  accept="image/png, image/gif, image/jpeg, application/pdf"
                  className="fileInput"
                  id="pan-modal-file-input"
                  type="file"
                  style={{ display: 'none' }}
                  onChange={(e) => {
                    if (e.target.files[0]) {
                      setUploadPanForVerification(e.target.files[0]);
                      const reader = new FileReader();
                      reader.onload = (event) => setPanPreviewForVerification(event.target.result);
                      reader.readAsDataURL(e.target.files[0]);
                    }
                  }}
                />

                {/* Image Display / File Browser Button */}
                <label
                  htmlFor="pan-modal-file-input"
                  style={{ cursor: 'pointer', display: 'block' }}
                >
                  <Box
                    sx={{
                      border: '2px dashed #1976d2',
                      borderRadius: '8px',
                      padding: '20px',
                      textAlign: 'center',
                      backgroundColor: '#f5f5f5',
                      minHeight: '200px',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: 'pointer',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        backgroundColor: '#e3f2fd',
                        borderColor: '#1565c0'
                      }
                    }}
                  >
                    {uploadPanForVerification ? (
                      <img
                        src={panPreviewForVerification}
                        alt="PAN Preview"
                        style={{
                          maxWidth: '100%',
                          maxHeight: '180px',
                          objectFit: 'contain'
                        }}
                      />
                    ) : (
                      <Box sx={{ textAlign: 'center' }}>
                        <Typography variant="body2" sx={{ color: '#666', mb: 1 }}>
                          📁 Click to browse or drag & drop
                        </Typography>
                        <Typography variant="caption" sx={{ color: '#999' }}>
                          PNG, JPG, GIF, or PDF
                        </Typography>
                      </Box>
                    )}
                  </Box>
                </label>
              </Box>

              {/* Step 2: PAN Number Input */}
              <Box>
                <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1.5 }}>
                  PAN Number
                </Typography>
                <TextField
                  fullWidth
                  label="PAN Number"
                  value={panNumber}
                  onChange={(e) => setPanNumber(e.target.value.toUpperCase().slice(0, 10))}
                  placeholder="Enter 10-character PAN (e.g., HGOPS2791P)"
                  variant="outlined"
                  inputProps={{
                    maxLength: 10
                  }}
                  helperText={`${panNumber.length}/10 characters`}
                />
              </Box>

              {/* Step 3: Full Name Input */}
              <Box>
                <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1.5 }}>
                  Full Name
                </Typography>
                <TextField
                  fullWidth
                  label="Full Name"
                  value={panName}
                  onChange={(e) => setPanName(e.target.value)}
                  placeholder="Enter full name (as per PAN)"
                  variant="outlined"
                />
              </Box>

              {/* Step 4: Date of Birth Input */}
              <Box>
                <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1.5 }}>
                  Date of Birth
                </Typography>
                <TextField
                  fullWidth
                  type="date"
                  label="DOB"
                  value={panDob}
                  onChange={(e) => setPanDob(e.target.value)}
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true
                  }}
                />
              </Box>
            </Box>
          </DialogContent>

          <DialogActions sx={{ p: 2, gap: 1 }}>
            <Button
              variant="outlined"
              onClick={() => {
                setPanModalOpen(false);
                setPanNumber('');
                setPanName('');
                setPanDob('');
                setUploadPanForVerification(null);
                setPanPreviewForVerification('');
              }}
            >
              Cancel
            </Button>

            <Button
              variant="contained"
              onClick={() => handlePanVerify()}
              disabled={
                panVerificationLoading ||
                !panNumber ||
                panNumber.length < 10 ||
                !panName ||
                !panDob ||
                !uploadPanForVerification
              }
              sx={{
                minWidth: '100px'
              }}
            >
              {panVerificationLoading ? 'Verifying...' : 'Verify'}
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </Page>
  );
}
export default AddEditOnBoarding;
